<template>
  <div class="position-relative">
    <section class="section-shaped my-0 py-2">
      <div class="shape shape-style-1 shape-primary shape-skew">
      </div>
      <div class="container pt-lg custom-padding-bottom-cover">
      <v-wait for="person.profile.load" transition="fade" :duration="750"> 
        <template slot="waiting">
          <div class="row justify-content-between align-items-center">
            <div class="col-lg-6 mb-lg-auto">
                <div class="rounded overflow-hidden transform-perspective-left">
                    <card type="secondary"
                      :class="['capa-filme']"
                      bodyClasses="p-1 bg-white border-0">
                      <template>
                          <div class="ph-col-12 ph-cover"></div>
                      </template>
                    </card>
                </div>
            </div>
            <div class="col-lg-6 mb-5 mb-lg-0">
                <div class="ph-container">
                  <div class="ph-col-12 ph-title mb-2"></div>
                  <div class="ph-col-10 clear ph-subtitle"></div>
                  <div class="ph-col-5 ph-text"></div>
                </div>
            </div>
          </div>
        </template>
        <div class="row justify-content-between align-items-center">
          <div class="col-lg-6 mb-lg-auto">
              <div class="rounded overflow-hidden transform-perspective-left">
                  <card type="secondary"
                    :class="['capa-filme']"
                    bodyClasses="p-1 bg-white border-0">
                    <template>
                        <img v-lazy="foto" class="card-img-top" v-if="!$wait.is('person.profile.load')">
                          <div class="lazyOverlay">
                            <img src="img/tail-spin.svg">
                        </div>
                    </template>
                  </card>
              </div>
          </div>
          <div class="col-lg-6 mb-5 mb-lg-0">
            <h1 class="text-white display-2 movie-title">{{person.nome}}</h1>
            <p class="lead dublagem mt-1">
              <span class="text-white aka mb-4" v-if="person.aka"><small><strong>Também conhecido como:</strong><br>{{person.aka}}</small></span>
              <span class="badge badge-white text-default mb-4 d-table" v-if="person.filmografia.length > 0">presente em {{person.filmografia.length}} {{ this.person.filmografia > 1 ? 'títulos' : 'título' }}</span>
              <span class="badge badge-white text-default mb-4 d-table" v-else>nenhum título vinculado</span>
              <base-button type="primary" icon="fa fa-external-link" v-if="urlIMDbProfile !== null" :href="urlIMDbProfile" tag="a" target="_blank">
                  Acessar IMDb
              </base-button>
              <base-button type="success" icon="fa fa-film" v-if="person.filmografia.length > 0" @click="goToMedia()">
                  Ver Mídias
              </base-button>
            </p>
          </div>
        </div>
      </v-wait>
      </div> 
    </section>
  </div>
</template>
<script>

import {scrollPageTo} from '@/plugins/scrollPageTo';

export default {
  name: 'personHeaderHero',
  computed: {
    person() {
      return this.$store.state.catalog.person
    },
    foto() {
      return this.axios.defaults.baseURL + this.person.foto
    },
    urlIMDbProfile() {
      return (this.person.imdb) ? `https://www.imdb.com/name/nm${this.person.imdb}/` : null
    }
  },
  methods: {
    goToMedia(){
      return scrollPageTo('#midias');
    }
  }
};
</script>
<style scoped>
  .movie-title {
    line-height: 1.1;
  }

  .aka {
    white-space: pre-wrap; 
    word-wrap: break-word;
    line-height: 1;
    display: block;
    margin-top: 15px;
  }

  .movie-title span {
    font-size: 0.65em;
    margin-top: 15px;
  }

  .custom-padding-bottom-cover {
    padding-bottom: 1.5rem;
  }
  .ph-title {
    height: 35px;
  }
  .ph-subtitle {
    height: 25px;
    margin-bottom: 25px;
  }
  .ph-text {
    height: 15px;
  }
  .ph-cover {
    height: 700px;
    margin-bottom: -5px;
  }

  @media screen and (max-width: 992px) {
    .capa-filme {
      max-width: 211px;
      margin: 0 auto;
      margin-bottom: 45px;
    }
    .ph-cover {
      height: 313px;
    }
    .movie-title {
      text-align: center;
    }
    .categoria, .dublagem {
      text-align: center;
    }

    .dublagem .badge {
      margin: 0 auto;
    }
  }
</style>
